import { Controller } from "@hotwired/stimulus"
import {
  DEFAULT_VALUES,
  DATERANGEPICKER_LOCALE,
  DATE_FORMAT
} from './consts'
import { mParseDate, linkTo } from 'utils'

// Connects to data-controller="date-picker--datetime"
export default class extends Controller {
  static targets = [ 'date' ]
  static values = {
    ...DEFAULT_VALUES,
    dateFormat: { type: String, default: 'YYYY/MM/DD hh:mm' }
  }

  dateTargetConnected() {
    this.updateDate(mParseDate(this.dateTarget.value))
  }

  connect() {
    // init datepicker
    const opts = {
      timePicker: true,
      locale: this.getDpLocale(),
      autoUpdateInput: this.autoUpdateInputValue || false,
      singleDatePicker: true,
      alwaysShowCalendars: true,
      startDate: this.dateTarget.value || moment(),
      autoApply: true,
      drops: 'auto',
      timePicker24Hour: true,
      showDropdowns: true,
      maxDate: !this.allowFutureValue && moment(),
      minDate: !this.allowPastValue && moment()
    }
    this.dp = new DateRangePicker(this.dateTarget, opts, this.onApply.bind(this))
  }

  updateDate(date) {
    if (date && typeof date != 'undefined' && date.isValid()) {
      this.dateTarget.value = date.format(this.dateFormatValue)
    }
  }

  onApply(date) {
    this.updateDate(date)
    this.autoForward()
  }

  autoSubmit() {
    if (this.autoSubmitValue) { this.dateTarget.form.requestSubmit() }
  }

  autoLinkTo() {
    const params = {}
    params[this.dateTarget.name] = this.dateTarget.value
    linkTo(params, this.currentParamsValue)
  }

  autoForward() {
    this.plaintextValue ? this.autoLinkTo() : this.autoSubmit()
  }

  getDpLocale() {
    return Object.assign(DATERANGEPICKER_LOCALE, { format: this.dateFormatValue })
  }
}
